/**
 * Load tooltip component.
 */
import {componentCommandName, componentKey, componentType, svg} from './editor';
import { hasRole, Role } from '../utils/user';

export function loadComponent(editor, opts = {}) {
  const {toolbarBtnTooltipContent} = opts;
  const canEdit = hasRole([Role.admin, Role.editor]);

  editor.Components.addType(componentType, {
    model: {
      defaults: {
        tagName: 'a',
        attributes: {
          'data-bs-toggle': 'tooltip',
          'data-bs-trigger': 'hover',
          'data-bs-content': '',
          'data-bs-placement': 'top',
          style: 'text-decoration:underline;cursor:pointer;',
          tabindex: '0',
          role: 'button',
          class: 'nv-tooltip'
        },
        editable: canEdit,
        draggable: canEdit,
        droppable: canEdit
      },
      init() {
        const toolbar = this.get('toolbar');
        const id = 'tooltip-content';

        // Add the tooltip content toolbar button if requested and if it's not already present
        if (toolbarBtnTooltipContent && !toolbar.filter(tlb => tlb.id === id).length) {
          toolbar.unshift({
            id,
            command: componentCommandName,
            label: svg,
            ...toolbarBtnTooltipContent
          });
        }

        if (!canEdit) {
          toolbar.length = 0;
        }
      }
    },
    view: {
      events: {
        dblclick: 'onActive',
      },
      onRender() {
        // Initialize Bootstrap tooltip after component is rendered
        this.initTooltip();
        
        // Listen for attribute changes to re-initialize tooltip (only once)
        if (!this._tooltipListenerAdded) {
          this.model.on('change:attributes', this.initTooltip, this);
          this._tooltipListenerAdded = true;
        }
      },
      
      initTooltip() {
        setTimeout(() => {
          const el = this.el;
          if (!el) return;

          const existingTooltip = bootstrap.Tooltip.getInstance(el);
          if (existingTooltip) {
            existingTooltip.dispose();
          }

          const attrs = this.model.get('attributes');
          const tooltipContent = attrs['data-bs-content'];

          if (tooltipContent && tooltipContent.trim() !== '') {
            new bootstrap.Tooltip(el, {
              title: tooltipContent,
              trigger: 'hover focus',
              placement: attrs['data-bs-placement'] || 'top',
              container: el.parentElement || 'body',
              html: true
            });
          }
        }, 100);
      },
      
      onActive() {
        const target = this.model;
        this.em.get('Commands').run(componentCommandName, {target});
      },
      
      onRemove() {
        // Clean up the change listener when component is removed
        if (this._tooltipListenerAdded) {
          this.model.off('change:attributes', this.initTooltip, this);
          this._tooltipListenerAdded = false;
        }
      }
    }
  });
};
